import Vue from 'vue';
import App from './App.vue';
import router from './router';
import 'je-marketing-components';

Vue.config.productionTip = true;

// eslint-disable-next-line
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
});
